import './scss/Settings.scss';

function Settings({ config, updateConfig, settings }) {
  const { servings, units, filter } = config;
  const { servingSizes, filterId } = settings;

  return (
    <section id="settings">
      <select 
        name="servings" 
        value={servings}
        onChange={(e) => updateConfig(e.target.name, e.target.value)}
      >
        { servingSizes.map(item => 
          <option value={item} key={item}>{item} servings</option>
        )}
      </select>
      <select 
        name="units" 
        value={units}
        onChange={(e) => updateConfig(e.target.name, e.target.value)} 
      >
        <option value="us">US measurements</option>
        <option value="metric">Metric</option>
      </select>
      { filterId ? 
        <div>
          <input 
            type="checkbox"
            id={filterId}
            name="filter"
            checked={filter}
            onChange={(e) => updateConfig(e.target.name, e.target.checked)}
          />
          <label htmlFor={filterId}>Tomato sauce from scratch</label>
        </div>
      : null 
      }
    </section>
  );
}

export default Settings;